// Bilingual strings for Queensway Studio (EN / FR)
export const translations = {
  en: {
    nav: {
      home: "Home",
      services: "Services",
      about: "About",
      journal: "Journal",
      booking: "Booking",
      contact: "Contact",
      bookNow: "Book Now",
    },
    hero: {
      overline: "Dakar · London",
      title: "Quiet luxury, refined beauty.",
      subtitle:
        "An intimate aesthetics atelier — bespoke treatments crafted with London-certified expertise, in the heart of Dakar.",
      ctaPrimary: "Reserve your visit",
      ctaSecondary: "Discover the studio",
      sigLabel: "EST. Queensway Studio",
    },
    marquee: ["Botox", "Derma Fillers", "IV Drips", "Lashes", "Brows", "Microblading"],
    intro: {
      overline: "The Maison",
      title: "An address for the modern muse.",
      body:
        "Queensway Studio is a discreet sanctuary where beauty is treated as a craft. Every treatment is composed for you — quietly, attentively, and with the precision of a London-trained hand.",
      cta: "Read our philosophy",
    },
    services: {
      overline: "The Atelier",
      title: "Signature services.",
      subtitle:
        "From injectable artistry to lash couture and wellness IV drips — each ritual is curated for refinement.",
      viewAll: "See full menu",
      categories: {
        botox: "Botox",
        fillers: "Derma Fillers",
        iv: "IV Drips",
        lashes: "Lash Couture",
        brows: "Brow Artistry",
      },
      duration: "Duration",
      from: "from",
      bookThis: "Book this service",
      priceOnConsult: "On consultation",
    },
    about: {
      overline: "Founder",
      title: "Trained in London. Devoted to Dakar.",
      body1:
        "Our founder holds professional credentials and certifications obtained in the United Kingdom — pairing clinical rigour with West-African warmth. The studio's main address is in Dakar, with appointments available in London by request.",
      body2:
        "Every visit follows a deliberate ritual: consultation, treatment, and quiet aftercare. We believe true elegance is felt long after you leave the room.",
      pillars: [
        { t: "UK-certified", d: "London-trained, internationally credentialed practitioner." },
        { t: "Bespoke", d: "Each protocol is composed for your face, never templated." },
        { t: "Discreet", d: "Private suite, single-client appointments, total confidentiality." },
      ],
      locDakar: "Dakar — Studio principal",
      locLondon: "London — On request",
    },
    booking: {
      overline: "Reservation",
      title: "Reserve your moment.",
      subtitle:
        "Tell us which ritual calls to you. We'll confirm by phone or email within 24 hours.",
      fullName: "Full name",
      email: "Email",
      phone: "Phone (WhatsApp preferred)",
      service: "Service",
      date: "Preferred date",
      time: "Preferred time",
      notes: "Additional notes (optional)",
      selectService: "Select a service",
      submit: "Request appointment",
      submitting: "Sending…",
      successTitle: "Appointment requested",
      successBody:
        "Thank you. Your appointment has been booked, but it may require a 10,000 FCFA deposit via Orange Money. The esthetician will reach out shortly to confirm.",
      newRequest: "Book another",
      errorMsg: "Something went wrong. Please try again or call us directly.",
    },
    contact: {
      overline: "Atelier",
      title: "Begin a conversation.",
      subtitle:
        "Reach us by phone, email, or send a private note. We respond personally.",
      sendNote: "Send a private note",
      yourName: "Your name",
      yourEmail: "Your email",
      yourMessage: "Your message",
      send: "Send",
      sending: "Sending…",
      sent: "Message sent — we'll reply shortly.",
      phone: "Phone",
      emailL: "Email",
      location: "Location",
      hours: "Hours",
      hoursValue: "Mon–Sat · 10:00 — 19:00",
    },
    chat: {
      title: "Concierge",
      subtitle: "Ask anything — services, prices, hours.",
      placeholder: "Type your question…",
      open: "Open concierge",
      close: "Close",
      send: "Send",
      welcome:
        "Welcome to Queensway Studio. How may I help you today?",
      thinking: "Composing…",
    },
    footer: {
      tagline: "Dakar · London — Beauty & Aesthetics Studio",
      rights: "All rights reserved.",
      sitemap: "Sitemap",
      legal: "Legal",
    },
    deposit: {
      note:
        "A 10,000 FCFA deposit via Orange Money may be required to confirm your appointment.",
    },
    auth: {
      loginTitle: "Welcome back",
      loginSubtitle: "Sign in to manage your appointments and rewards.",
      signupTitle: "Create your account",
      signupSubtitle: "It takes 30 seconds — then you can book in one click.",
      name: "Full name",
      email: "Email",
      password: "Password",
      dob: "Date of birth (optional)",
      dobHint: "Add it now and unlock 15% off in your birthday month — every year.",
      login: "Sign in",
      signup: "Create account",
      noAccount: "No account?",
      haveAccount: "Already a member?",
      signupHere: "Create one",
      loginHere: "Sign in",
      logout: "Logout",
      account: "My account",
      welcome: "Welcome",
      loggingIn: "Signing in…",
      signingUp: "Creating…",
      passwordHint: "At least 6 characters",
    },
    account: {
      title: "My account",
      myBookings: "My appointments",
      loyalty: "Loyalty",
      visitCount: "Confirmed visits",
      progress: "visits to your next reward",
      reward: "Free service at 10 visits ✦",
      empty: "No appointments yet. Book your first ritual.",
      status: {
        pending: "Pending",
        confirmed: "Confirmed",
        declined: "Declined",
        completed: "Completed",
      },
    },
    referral: {
      title: "Share the secret",
      body: "Refer a friend — they get 5,000 FCFA off their first IV Drip, and so do you.",
      whatsapp: "Share via WhatsApp",
      copy: "Copy invite link",
      copied: "Copied!",
    },
    birthday: {
      title: "Happy Birthday Month",
      subtitle: "From all of us at Queensway — a little gift for you.",
      offer: "15% off any service this month",
      yourCode: "Your code",
      copyCode: "Copy code",
      copied: "Copied!",
      expires: "Valid through",
      bookNow: "Book your birthday treat",
      addDob: "Add your birthday",
      dobSaved: "Birthday saved ✓",
    },
    aftercare: {
      title: "Aftercare ritual",
    },
    gallery: {
      title: "Before & after",
      subtitle: "Real results from the studio.",
      empty: "Gallery coming soon.",
      before: "Before",
      after: "After",
    },
    testimonials: {
      overline: "Voices",
      title: "What clients are saying.",
    },
    quiz: {
      title: "Find your ritual",
      subtitle: "Three questions. One personalized recommendation.",
      start: "Begin",
      next: "Next",
      result: "Your perfect ritual",
      bookRecommendation: "Book this ritual",
      retake: "Retake quiz",
    },
    giftCards: {
      title: "The Queensway gift",
      subtitle: "Offer the gift of beauty. A digital card, redeemable on any service.",
      buyerName: "Your name",
      buyerEmail: "Your email",
      buyerPhone: "Your phone",
      recipientName: "Recipient's name",
      amount: "Amount (FCFA)",
      message: "Personal message (optional)",
      submit: "Request gift card",
      success:
        "Thank you. We'll reach out to confirm payment via Orange Money and issue the digital code to send to your recipient.",
      processing: "Submitting…",
    },
    newsletter: {
      title: "Le carnet",
      subtitle: "Receive private offers, openings, and beauty notes.",
      placeholder: "Your email",
      subscribe: "Subscribe",
      success: "Welcome. Your 10% code:",
      already: "You're already with us. Your code:",
    },
    hours: {
      title: "Studio hours",
      days: {
        sunday: "Sunday",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
      },
      closed: "Closed",
    },
    whatsapp: {
      label: "WhatsApp",
    },
  },
  fr: {
    nav: {
      home: "Accueil",
      services: "Prestations",
      about: "À propos",
      journal: "Journal",
      booking: "Réservation",
      contact: "Contact",
      bookNow: "Réserver",
    },
    hero: {
      overline: "Dakar · Londres",
      title: "Le luxe discret de la beauté.",
      subtitle:
        "Un atelier d'esthétique intimiste — des soins sur mesure, signés par une expertise certifiée à Londres, au cœur de Dakar.",
      ctaPrimary: "Réservez votre visite",
      ctaSecondary: "Découvrir le studio",
      sigLabel: "EST. Queensway Studio",
    },
    marquee: ["Botox", "Acides hyaluroniques", "IV Drips", "Cils", "Sourcils", "Microblading"],
    intro: {
      overline: "La Maison",
      title: "Une adresse pour la muse moderne.",
      body:
        "Queensway Studio est un sanctuaire discret où la beauté se travaille comme un art. Chaque prestation est composée pour vous — avec attention, finesse et la précision d'une main formée à Londres.",
      cta: "Notre philosophie",
    },
    services: {
      overline: "L'Atelier",
      title: "Nos prestations signature.",
      subtitle:
        "De l'art de l'injection à la couture des cils et aux perfusions de bien-être — chaque rituel est conçu pour la raffinement.",
      viewAll: "Voir tout le menu",
      categories: {
        botox: "Botox",
        fillers: "Acides hyaluroniques",
        iv: "IV Drips",
        lashes: "Cils",
        brows: "Sourcils",
      },
      duration: "Durée",
      from: "à partir de",
      bookThis: "Réserver cette prestation",
      priceOnConsult: "Sur consultation",
    },
    about: {
      overline: "Fondatrice",
      title: "Formée à Londres. Dévouée à Dakar.",
      body1:
        "Notre fondatrice détient ses certifications professionnelles au Royaume-Uni — alliant rigueur clinique et chaleur ouest-africaine. L'adresse principale du studio est à Dakar, avec des rendez-vous disponibles à Londres sur demande.",
      body2:
        "Chaque visite suit un rituel précis : consultation, soin, accompagnement post-soin. La vraie élégance se ressent longtemps après avoir quitté la pièce.",
      pillars: [
        { t: "Certifiée UK", d: "Praticienne formée à Londres, accréditée à l'international." },
        { t: "Sur mesure", d: "Chaque protocole est composé pour votre visage, jamais standardisé." },
        { t: "Discrétion", d: "Suite privée, rendez-vous individuels, confidentialité totale." },
      ],
      locDakar: "Dakar — Studio principal",
      locLondon: "Londres — Sur demande",
    },
    booking: {
      overline: "Réservation",
      title: "Réservez votre instant.",
      subtitle:
        "Indiquez-nous le rituel qui vous appelle. Nous confirmerons sous 24h par téléphone ou email.",
      fullName: "Nom complet",
      email: "Email",
      phone: "Téléphone (WhatsApp de préférence)",
      service: "Prestation",
      date: "Date souhaitée",
      time: "Heure souhaitée",
      notes: "Notes additionnelles (optionnel)",
      selectService: "Sélectionner une prestation",
      submit: "Demander un rendez-vous",
      submitting: "Envoi en cours…",
      successTitle: "Demande envoyée",
      successBody:
        "Merci. Votre rendez-vous a été réservé, mais un acompte de 10 000 FCFA via Orange Money peut être requis. L'esthéticienne vous contactera prochainement pour confirmation.",
      newRequest: "Nouvelle demande",
      errorMsg:
        "Une erreur est survenue. Veuillez réessayer ou nous appeler directement.",
    },
    contact: {
      overline: "Atelier",
      title: "Commencez la conversation.",
      subtitle:
        "Joignez-nous par téléphone, email, ou laissez un message privé. Nous répondons personnellement.",
      sendNote: "Envoyer un message privé",
      yourName: "Votre nom",
      yourEmail: "Votre email",
      yourMessage: "Votre message",
      send: "Envoyer",
      sending: "Envoi…",
      sent: "Message envoyé — nous vous répondrons rapidement.",
      phone: "Téléphone",
      emailL: "Email",
      location: "Localisation",
      hours: "Horaires",
      hoursValue: "Lun–Sam · 10h00 — 19h00",
    },
    chat: {
      title: "Concierge",
      subtitle: "Posez toutes vos questions — prestations, tarifs, horaires.",
      placeholder: "Écrivez votre question…",
      open: "Ouvrir le concierge",
      close: "Fermer",
      send: "Envoyer",
      welcome:
        "Bienvenue chez Queensway Studio. Comment puis-je vous aider aujourd'hui ?",
      thinking: "Rédaction…",
    },
    footer: {
      tagline: "Dakar · Londres — Studio Beauté & Esthétique",
      rights: "Tous droits réservés.",
      sitemap: "Plan du site",
      legal: "Mentions légales",
    },
    deposit: {
      note:
        "Un acompte de 10 000 FCFA via Orange Money peut être requis pour confirmer votre rendez-vous.",
    },
    auth: {
      loginTitle: "Bon retour",
      loginSubtitle: "Connectez-vous pour gérer vos rendez-vous et fidélité.",
      signupTitle: "Créez votre compte",
      signupSubtitle: "30 secondes — ensuite vous réservez en un clic.",
      name: "Nom complet",
      email: "Email",
      password: "Mot de passe",
      dob: "Date de naissance (optionnel)",
      dobHint: "Ajoutez-la maintenant et débloquez 15% de réduction le mois de votre anniversaire — chaque année.",
      login: "Se connecter",
      signup: "Créer un compte",
      noAccount: "Pas de compte ?",
      haveAccount: "Déjà membre ?",
      signupHere: "Créer",
      loginHere: "Se connecter",
      logout: "Déconnexion",
      account: "Mon compte",
      welcome: "Bienvenue",
      loggingIn: "Connexion…",
      signingUp: "Création…",
      passwordHint: "Au moins 6 caractères",
    },
    account: {
      title: "Mon compte",
      myBookings: "Mes rendez-vous",
      loyalty: "Fidélité",
      visitCount: "Visites confirmées",
      progress: "visites avant votre prochaine récompense",
      reward: "Un soin offert à la 10ème visite ✦",
      empty: "Aucun rendez-vous. Réservez votre premier rituel.",
      status: {
        pending: "En attente",
        confirmed: "Confirmé",
        declined: "Refusé",
        completed: "Effectué",
      },
    },
    referral: {
      title: "Partagez le secret",
      body: "Parrainez une amie — elle reçoit 5 000 FCFA de réduction sur son premier IV Drip, et vous aussi.",
      whatsapp: "Partager via WhatsApp",
      copy: "Copier le lien",
      copied: "Copié !",
    },
    birthday: {
      title: "Joyeux mois d'anniversaire",
      subtitle: "Toute l'équipe Queensway vous offre un petit cadeau.",
      offer: "15% de réduction sur toutes les prestations ce mois-ci",
      yourCode: "Votre code",
      copyCode: "Copier le code",
      copied: "Copié !",
      expires: "Valable jusqu'au",
      bookNow: "Réserver votre rituel d'anniversaire",
      addDob: "Ajouter votre date de naissance",
      dobSaved: "Date enregistrée ✓",
    },
    aftercare: {
      title: "Rituel post-soin",
    },
    gallery: {
      title: "Avant & après",
      subtitle: "Des résultats vrais, depuis l'atelier.",
      empty: "Galerie bientôt disponible.",
      before: "Avant",
      after: "Après",
    },
    testimonials: {
      overline: "Témoignages",
      title: "Ce que disent nos clientes.",
    },
    quiz: {
      title: "Trouvez votre rituel",
      subtitle: "Trois questions. Une recommandation personnalisée.",
      start: "Commencer",
      next: "Suivant",
      result: "Votre rituel idéal",
      bookRecommendation: "Réserver ce rituel",
      retake: "Refaire le quiz",
    },
    giftCards: {
      title: "Le cadeau Queensway",
      subtitle: "Offrez le cadeau de la beauté. Une carte digitale, valable sur toutes les prestations.",
      buyerName: "Votre nom",
      buyerEmail: "Votre email",
      buyerPhone: "Votre téléphone",
      recipientName: "Nom de la destinataire",
      amount: "Montant (FCFA)",
      message: "Message personnel (optionnel)",
      submit: "Demander la carte",
      success:
        "Merci. Nous vous contacterons pour confirmer le paiement Orange Money et émettre le code à transmettre à votre destinataire.",
      processing: "Envoi…",
    },
    newsletter: {
      title: "Le carnet",
      subtitle: "Recevez nos offres privées, ouvertures et notes beauté.",
      placeholder: "Votre email",
      subscribe: "S'inscrire",
      success: "Bienvenue. Votre code 10% :",
      already: "Vous êtes déjà avec nous. Votre code :",
    },
    hours: {
      title: "Horaires du studio",
      days: {
        sunday: "Dimanche",
        monday: "Lundi",
        tuesday: "Mardi",
        wednesday: "Mercredi",
        thursday: "Jeudi",
        friday: "Vendredi",
        saturday: "Samedi",
      },
      closed: "Fermé",
    },
    whatsapp: {
      label: "WhatsApp",
    },
  },
};

export const LOCAL_STORAGE_KEY = "queensway_lang";
